import React from 'react';
import Text from './Text';
import { useTranslation } from 'react-i18next';

const LoyaltyTitle: React.FC<{ title: string }> = ({ title }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      <Text themeKey="loyaltyHeader" value={t(title)} />
    </div>
  );
};

export default LoyaltyTitle;
